import { FormikProps } from 'formik';
import { useRef, useEffect } from 'react';

type Props<TValue> = {
    open: boolean;
    formProps: FormikProps<TValue>;
    initialValues: TValue;
};

// Resets Formik to initialValues when the dialog closes, so reopening starts fresh
export function FormResetOnClose<TValue = any>({ open, formProps, initialValues }: Props<TValue>) {
    const prevOpenRef = useRef(open);
    useEffect(() => {
        if (prevOpenRef.current && !open) {
            formProps.resetForm({ values: initialValues as TValue });
        }
        prevOpenRef.current = open;
    }, [open]); // eslint-disable-line react-hooks/exhaustive-deps
    return null;
}
